import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Popover,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const MobileAccordion = ({ items }) => {
  const [expanded, setExpanded] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverText, setPopoverText] = useState("");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handlePopoverOpen = (event, text) => {
    setAnchorEl(event.currentTarget);
    setPopoverText(text);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverText("");
  };

  const open = Boolean(anchorEl);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 400, // Mimic mobile app container width
        margin: "auto",
        borderRadius: 2,
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        overflow: "hidden",
      }}
    >
      {items.map((item, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
          disableGutters
          sx={{
            borderBottom: "1px solid #ddd",
            "&:before": { display: "none" }, // Remove default MUI divider
            "&.Mui-expanded": { boxShadow: "none" }, // Remove shadow when expanded
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              backgroundColor: "#f9f9f9",
              padding: "0 16px",
              "&.Mui-expanded": {
                backgroundColor: "#e6e6e6", // Highlight background when expanded
              },
            }}
          >
            <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "8px 16px",
              backgroundColor: "#fff",
              fontSize: 14,
              color: "#555",
              lineHeight: 1.6,
            }}
          >
            {item.buttons?.map((button, btnIndex) => (
              <div
                key={btnIndex}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <button
                  style={{
                    width: "300px", // Ensures all buttons have the same width
                    padding: "10px 20px",
                    fontSize: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => console.log(`Selected: ${button.type}`)}
                >
                  {button.text}
                </button>
                {button.info && (
                  <InfoOutlinedIcon
                    fontSize="large"
                    sx={{
                      marginLeft: 2,
                      cursor: "pointer",
                      color: "yellow",
                    }}
                    onClick={(event) =>
                      handlePopoverOpen(event, button.info)
                    }
                  />
                )}
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}

      {/* Popover for Info Icon */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 250 }}>
          <Typography>{popoverText}</Typography>
        </Box>
      </Popover>
    </Box>
  );
};

export default MobileAccordion;
